module.exports = __webpack_public_path__ + "static/media/gem3.87bd49b5.png";